import { cn } from '@bem-react/classname';

const cnHeader = cn('Header');

export const headerCn = cnHeader();
export const headerContainerCn = cnHeader('Container');
export const headerTitleCn = cnHeader('Title');
export const headerLanguageCn = cnHeader('Language');
export const headerSwitchCn = cnHeader('Switch');
export const headerSkeletonCn = cnHeader('Skeleton');
